import React, { useState, useEffect } from 'react'
import { includes, xor } from 'lodash/fp'
import { useWithAuth } from '../../containers/App'
import Checkbox from '../../components/Checkbox'
import styled from 'styled-components'
import { useMutation } from 'react-query'
import Table from '../../components/Table'
import { useNotifications } from '../../containers/Notifications'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
// @ts-ignore @todo add apprioprate declaration file
import addIcon from '../../images/addIcon.svg'

function SendSurvey() {
  const surveyId = location.pathname.substring(
    location.pathname.lastIndexOf('/') + 1
  )
  const [ready, setReady] = useState({ patients: false, users: false })
  const [selection, setSelection] = useState([])
  const [ids, setIds] = useState([])
  const [isParent, setIsParent] = useState(false)
  const [isTeacher, setIsTeacher] = useState(false)
  const [patientsData, setPatientsData] = useState([])
  const [filteredPatientsData, setFilteredPatientsData] = useState([])
  const endpoint = '/form/rest/survey/request/survey/'
  const patientsEndpoint = '/form/rest/survey/request/recipients'
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const [mutate] = useMutation<any, Array<string>>((values) =>
    withAuth(`${endpoint}${surveyId}`, {
      method: 'POST',
      payload: { emails: values },
    })
      .then((res) => {
        if ('fieldErrors' in res) {
          // @todo notifications
        } else {
          notify('Zlecono wysyłkę ankiet', 'success')
        }
      })
      .catch((e) => {
        e.status === 403 && notify(' brak wymaganych uprawnień', 'error')
      })
  )

  const fetchPatients = async () => {
    setReady({ ...ready, patients: false })
    const result = await withAuth(patientsEndpoint, {
      method: 'GET',
    })
    setReady({ ...ready, patients: true })
    return result
  }

  const fetchData = async () => {
    try {
      const resultPatients = await fetchPatients()
      setPatientsData(resultPatients)
      setFilteredPatientsData(
        resultPatients.map((patient, index) => ({ ...patient, id: index }))
      )
    } catch {
      notify('Nie udało się pobrać użytkowników', 'error')
    }
  }
  const handlePatientsFiltering = (e) => {
    const fullName = e.split(/(\s)/) //splits whitespaces
    const arrayOfPatients = patientsData.filter(
      (patient) =>
        (patient.firstName.toLowerCase().includes(fullName[0]) ||
          patient.lastName.toLowerCase().includes(fullName[0])) &&
        (fullName[2]
          ? patient.lastName.toLowerCase().includes(fullName[2])
          : true)
    )
    setFilteredPatientsData(
      arrayOfPatients.map((patient, index) => ({ ...patient, id: index }))
    )
    setSelection([])
  }
  const handleSubmit = () => {
    const normalisedPatients =
      ((isParent ? isTeacher : !isTeacher) &&
        selection.map((val) => [
          filteredPatientsData[val].parent1Email,
          filteredPatientsData[val].parent2Email,
          filteredPatientsData[val].teacher1Email,
          filteredPatientsData[val].teacher2Email,
        ])) ||
      (isParent &&
        selection.map((val) => [
          filteredPatientsData[val].parent1Email,
          filteredPatientsData[val].parent2Email,
        ])) ||
      (isTeacher &&
        selection.map((val) => [
          filteredPatientsData[val].teacher1Email,
          filteredPatientsData[val].teacher2Email,
        ]))
    const normalisedValues = normalisedPatients
      .flat()
      .filter(
        (value, index) =>
          value !== null && normalisedPatients.flat().indexOf(value) === index
      )
    mutate(normalisedValues)
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    setIds(filteredPatientsData.map((val, index) => index))
  }, [filteredPatientsData])

  return (
    <Layout>
      <Heading title="Ankiety">
        <Button
          link={null}
          onClick={() => handleSubmit()}
          label="Udostępnij"
          icon={addIcon}
          altTag=""
          imgAriaHidden={true}
          width="auto"
        />
      </Heading>
      <SurveyWrapper>
        <TitleWrapper>
          <StyledH3>Wyślij do</StyledH3>
          <input
            aria-label="wyślij do"
            onChange={(e) =>
              handlePatientsFiltering(e.target.value.toLowerCase())
            }
            placeholder="Wpisz imię i nazwisko"
          ></input>
        </TitleWrapper>
        <Title>Rola</Title>
        <StyledDiv>
          <Checkbox
            hiddenLabel
            label={false} //it accepts boolean and uses as condition
            aria-label="Rola Rodzic"
            input={{
              value: isParent,
              onChange: () => {
                setIsParent(!isParent)
              },
            }}
          />
          <StyledParentSpan>Rodzic</StyledParentSpan>
          <Checkbox
            hiddenLabel
            label={false} //it accepts boolean and uses as condition
            aria-label="Rola Nauczyciel"
            input={{
              value: isTeacher,
              onChange: () => {
                setIsTeacher(!isTeacher)
              },
            }}
          />
          <StyledParentSpan>Nauczyciel</StyledParentSpan>
        </StyledDiv>
        <Table
          data={filteredPatientsData}
          getTrProps={() => ({
            style: {
              display: 'flex',
              alignItems: 'center',
              lineHeight: '90px',
            },
          })}
          getLoadingProps={() => ({
            'aria-hidden': true,
            role: 'none',
          })}
          getTheadTrProps={() => ({
            style: { display: 'flex', alignItems: 'center' },
          })}
          columns={[
            {
              id: 'cumulation',
              sortable: false,
              resizable: false,
              Header: (
                <Checkbox
                  hiddenLabel
                  label={false} //it accepts boolean and uses as condition
                  aria-label="Zaznacz wszystkie osoby na stronie"
                  input={{
                    value: xor(ids, selection).length === 0,
                    onChange: () => {
                      setSelection(xor(ids, selection).length === 0 ? [] : ids)
                    },
                  }}
                />
              ),
              Cell: ({ original }) => (
                <Checkbox
                  hiddenLabel
                  label={false} //it accepts boolean and uses as condition
                  aria-label="Zaznacz wszystkie osobę"
                  input={{
                    value: includes(original.id, selection),
                    onChange: () => setSelection(xor([original.id], selection)),
                  }}
                />
              ),

              getProps: () => ({
                onClick: (e) => e.stopPropagation(),
              }),
            },
            {
              id: 'fullName',
              Header: 'Imię i nazwisko',
              sortable: false,
              Cell: ({ original }) => (
                <span role="gridcell">{`${original.firstName} ${original.lastName}`}</span>
              ),
            },
            {
              id: 'birthDate',
              accessor: 'dateOfBirth',
              Header: 'Data urodzenia',
              sortable: false,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              id: 'parentsEmail',
              Header: 'E-mail rodzica',
              sortable: false,
              Cell: ({ original }) => (
                <>
                  <StyledSpan>{`${
                    original.parent1Email === null
                      ? '(brak)'
                      : original.parent1Email
                  }`}</StyledSpan>
                  <span>{`${
                    original.parent2Email === null
                      ? '(brak)'
                      : original.parent2Email
                  }`}</span>
                </>
              ),
            },
            {
              id: 'teachersEmail',
              Header: 'E-mail nauczyciela',
              sortable: false,
              Cell: ({ original }) => (
                <>
                  <StyledSpan>{`${
                    original.teacher1Email === null
                      ? '(brak)'
                      : original.teacher1Email
                  }`}</StyledSpan>
                  <span>{`${
                    original.teacher2Email === null
                      ? '(brak)'
                      : original.teacher2Email
                  }`}</span>
                </>
              ),
            },
          ]}
        />
      </SurveyWrapper>
    </Layout>
  )
}

export default SendSurvey

const SurveyWrapper = styled.div`
  margin: 5vh 10vw;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.p`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 21px;

  text-transform: uppercase;
  margin-top: 3rem;
`
const StyledSpan = styled.span`
  margin: 0;
  max-height: 22px;
  display: flex;
`

const StyledParentSpan = styled.span`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  display: flex;
  align-items: center;
`
const StyledH3 = styled.h3`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
`

const StyledDiv = styled.div`
  max-width: 20%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
`
